import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { company, navLinks } from '../../data/company';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 border-b border-edge bg-ink/95 backdrop-blur" data-id="element-125" data-mp="m12zejazk2fo">
      <div className="mx-auto flex h-20 max-w-[1320px] items-center justify-between gap-6 px-5 md:px-8" data-id="element-126" data-mp="i0socs8c6lty">
        <Link to="/" aria-label="Universal Packaging Industries, home" className="shrink-0" data-id="element-127" data-mp="vrxl9mkbl00l">
          <img src={company.logoHeader} alt="Universal Packaging Industries LLC" className="h-8 w-auto sm:h-9 md:h-10" data-id="element-128" data-mp="qyl7y8l3cfn5" />
        </Link>

        <nav aria-label="Main" className="hidden xl:block" data-id="element-129" data-mp="3ugml8x9buikp">
          <ul className="flex items-center gap-1 rounded-full border border-edge bg-coal p-1.5" data-id="element-130" data-mp="3ug3ca61nn4it">
            {navLinks.map(link => <li key={link.to} data-id="element-131" data-mp="burqzbzgoza7">
                <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `block whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold uppercase tracking-[0.06em] transition-colors duration-150 ${isActive ? 'bg-flame text-ink' : 'text-chalk/75 hover:text-chalk'}`} data-id="element-132" data-mp="btq66fsn8yfa">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-133" data-mp="1wluj9wfclcq">
          <Link to="/contact" className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-flame px-6 py-3 text-sm font-bold uppercase tracking-[0.06em] text-ink transition-colors duration-150 hover:bg-chalk sm:inline-flex" data-id="element-134" data-mp="1xdd9k4xaoll">
            Request a Quote
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="3ab24h4floc1f" />
          </Link>
          <button type="button" onClick={() => setOpen(value => !value)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-edge text-chalk xl:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-136" data-mp="35c8tbinscx4f">
            {open ? <XIcon className="h-5 w-5" data-id="element-137" data-mp="2mnc7m36gfcxt" /> : <MenuIcon className="h-5 w-5" data-id="element-138" data-mp="2mo3qcdeydg6o" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-139" data-mp="30f8v1tx6gynv">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-20 border-b border-edge bg-ink xl:hidden" data-id="element-140" data-mp="30g1wqgha4xz5">
            <ul className="mx-auto max-w-[1320px] px-5 py-4 md:px-8" data-id="element-141" data-mp="ifhkpejqb4uy">
              {navLinks.map(link => <li key={link.to} data-id="element-142" data-mp="n9lo5ntscura">
                  <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `block border-b border-edge py-4 text-center font-display text-3xl font-bold uppercase ${isActive ? 'text-flame' : 'text-chalk'}`} data-id="element-143" data-mp="9gmazshh7cmw">
                    {link.label}
                  </NavLink>
                </li>)}
              <li className="pt-5" data-id="element-144" data-mp="x5f1vaj8quan">
                <Link to="/contact" className="flex items-center justify-center gap-2 rounded-full bg-flame py-4 font-bold uppercase text-ink" data-id="element-145" data-mp="x4dnox6xhrop">
                  Request a Quote
                  <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-146" data-mp="3htte3r28jedt" />
                </Link>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}